/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindAdmissionStatusOptions200Response
 */
export interface FindAdmissionStatusOptions200Response {
    /**
     * Map of lead_id to its admission-status options.
     * @type {{ [key: string]: any; }}
     * @memberof FindAdmissionStatusOptions200Response
     */
    data?: { [key: string]: any; } | null;
}

/**
 * Check if a given object implements the FindAdmissionStatusOptions200Response interface.
 */
export function instanceOfFindAdmissionStatusOptions200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAdmissionStatusOptions200ResponseFromJSON(json: any): FindAdmissionStatusOptions200Response {
    return FindAdmissionStatusOptions200ResponseFromJSONTyped(json, false);
}

export function FindAdmissionStatusOptions200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAdmissionStatusOptions200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
    };
}

export function FindAdmissionStatusOptions200ResponseToJSON(value?: FindAdmissionStatusOptions200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
    };
}

